export default __webpack_public_path__ + "static/media/move-site.5b6f15a6.webp";